import { START_LOCATION } from 'vue-router';

// Global guard of the session (src/utils/auth/sessionService.js): every route but the public ones (meta.public,
// the login page) needs a session. The initial navigation waits for the boot to decide (remembered session,
// SSO handoff, or none), then the URL stays where it is: a reload of '/' shows the portal, of /agenda the agenda.

// Only a path of this application: an absolute or protocol-relative URL would be an open redirect.
export function safeRedirect(value) {
	const path = Array.isArray(value) ? value[0] : value;
	return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\') ? path : null;
}

/**
 * @param {object} deps
 * @param {() => Promise<unknown>} deps.whenResolved   the boot decided
 * @param {() => boolean} deps.isAuthenticated
 * @param {() => string|null} deps.takeLanding          where an SSO handoff asked to land (once)
 * @param {() => boolean} deps.canOpenApplication      the web application is enabled for the customer
 */
export function createSessionGuard({ whenResolved, isAuthenticated, takeLanding, canOpenApplication }) {
	return async (to, from) => {
		await whenResolved();

		if (to.meta?.public) {
			if (to.name === 'Login' && isAuthenticated()) return { path: safeRedirect(to.query?.redirect) ?? '/', replace: true };
			return true;
		}
		if (!isAuthenticated()) return { name: 'Login', query: to.fullPath === '/' ? {} : { redirect: to.fullPath }, replace: true };

		if (from === START_LOCATION) {
			const landing = takeLanding();
			if (landing && landing !== to.fullPath) return { path: landing, replace: true };
		}
		// home.js only showed the eCOS tile with the WebAppSalesFO option: the application cannot open without it.
		if (to.meta?.legacyView && !canOpenApplication()) return { name: 'Portal', replace: true };
		return true;
	};
}
